import React, { useCallback, useEffect, useRef } from 'react';
import ModalCommon from 'components/Input/ModalCommon';
import Button from 'components/Button';
import Spin from 'antd/lib/spin';
import { useState } from 'react';
import Editor from 'components/Editor/Editor';
import { toolbarOptions3 } from 'assets/sheets/images';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import { NO_INTERNET } from 'components/messageError';
import { toast } from 'sonner';

const InvoicePopup = ({
  isOpen,
  onCancel,
  invoiceId,
  onSuccess,
}) => {

  const invoiceRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    invoice: '',
  });
  const [resetKey, setResetKey] = useState(0);

  const handleAfterOpen = useCallback(() => {
    const modalBody = document.querySelector('.ant-modal-body');
    if (modalBody) {
      modalBody.scrollTop = 0;
    }
  }, []);

   const getInfoUser = () => {
    setLoading(true);
    CourseScheduleRegistationServices.getInfo(invoiceId)
      .then((res) => {
        setForm({
          invoice : res.data.invoice
        });
        setResetKey((k) => k + 1); // Reset editor after data is loaded
      })
      .catch((err) => toast.error(err?.message || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (isOpen && invoiceId) {
      getInfoUser();
    } else if (!isOpen) {
      // Clear form when modal closes
      setForm({ invoice: '' });
    }
  }, [isOpen, invoiceId]);

  const updateInvoice = () => {
    setLoading(true);
    CourseScheduleRegistationServices.updateCourseRegistration(invoiceId, {
      invoice: (form.invoice),
    })
      .then((res) => {
        if (res.data) {
          onSuccess(); // This should trigger parent to refetch data
          onCancel();
        }
      })
      .catch((err) => {
        toast.error(err.message || NO_INTERNET);
      })
      .finally(() => setLoading(false));
  };

  const handleChangeData = ({ label, value }) => {
    setForm({
      ...form,
      [label]: value,
    });
  };

  const handleSave = () => {
    updateInvoice();
  };
  return (
    <ModalCommon
      width={600}
      onAfterOpen={handleAfterOpen}
      title={'請求書'}
      loading={loading}
      open={isOpen}
      onCancel={() => {
        setForm({
          invoice: '',
        });
        invoiceRef.current?.reset();
        onCancel();
      }}
      heightHeader={56}
      footer={
        <div className="flex h-max justify-end gap-4 border-t border-[#e9e9e9] pt-4">
          <Button
            btnType="back"
            onClick={() => {
              setForm({
                invoice: '',
              });
              invoiceRef.current?.reset();
              onCancel();
            }}
            fontSize={14}
            width={120}
            height={40}
          >
            キャンセル
          </Button>
          <Button
            btnType="primary"
            onClick={handleSave}
            fontSize={14}
            height={40}
            width={120}
          >
            <p style={{ letterSpacing: '0', fontSize: '14px' }}>保存</p>
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <Editor
          ref={invoiceRef}
          label={'請求書'}
          title="invoice"
          alignLabel="center"
          widthLabel={142}
          options={[toolbarOptions3]}
          widthEditor={399}
          heightEditor={260}
          value={form.invoice ?? ''}
          resetKey={resetKey}
          onChange={handleChangeData}
        />
      </Spin>
    </ModalCommon>
  );
};

export default InvoicePopup;
